import { render, staticRenderFns } from "./MyTerritory.vue?vue&type=template&id=79caacda&scoped=true"
import script from "./MyTerritory.vue?vue&type=script&lang=js"
export * from "./MyTerritory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79caacda",
  null
  
)

export default component.exports